module.exports = __webpack_public_path__ + "img/footer.cda90a91.png";